import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Banner Saga ***************************
export function* fetchBannerSaga(action) {
  try {
    yield put(Creators.fetchBannerStart());
    const url = yield apiEndpoints.bannerData;
    const res = yield axios.get(url);
    const bannerData = [];
    for (let key in res.data.TrendingPosts) {
      bannerData.push({
        id: key,
        ...res.data.TrendingPosts[key]
      });
    }
    yield put(Creators.fetchBannerSuccess(bannerData));
  } catch (err) {
    yield put(Creators.fetchBannerFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Trending Tags Saga ***************************
export function* fetchTrendingTagsSaga(action) {
  try {
    yield put(Creators.fetchTrendingTagsStart());
    const url = yield apiEndpoints.trendingTags;
    const res = yield axios.get(url);
    const trendingTags = [];
    if (res.data.success === 1) {
      for (let key in res.data.tags) {
        trendingTags.push({
          id: key,
          ...res.data.tags[key]
        });
      }
    }
    yield put(Creators.fetchTrendingTagsSuccess(trendingTags));
  } catch (err) {
    yield put(Creators.fetchTrendingTagsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Recent News Saga ***************************
export function* fetchRecentNewsSaga(action) {
  try {
    yield put(Creators.fetchRecentNewsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.recentNews;
    } else {
      url = yield `${apiEndpoints.recentNews}/page/${action.pageNumber}`;
    }
    const res = yield axios.get(url);
    const recentNews = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        recentNews.push({
          id: key,
          ...res.data.categoryPosts[key]
        });
      }
    }
    yield put(Creators.fetchRecentNewsSuccess(recentNews));
  } catch (err) {
    yield put(Creators.fetchRecentNewsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Top News Saga ***************************
export function* fetchTopNewsSaga(action) {
  try {
    yield put(Creators.fetchTopNewsStart());
    const url = yield apiEndpoints.topNews;
    const res = yield axios.get(url);
    const topNews = [];
    if (res.data.success === 1) {
      for (let key in res.data.Top) {
        topNews.push({
          id: key,
          ...res.data.Top[key]
        });
      }
    }
    // console.log('topNews: ', topNews);
    yield put(Creators.fetchTopNewsSuccess(topNews));
  } catch (err) {
    yield put(Creators.fetchTopNewsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Increase Post Count Saga ***************************
export function* increasePostCountSaga(action) {
  // console.log('action: ', action);
  try {
    const url = yield `${apiEndpoints.increasePostCount}/${action.postId}`;
    const res = yield axios.post(url);
    // console.log('res: ', res);
    if (res.data.success === 1) {
      return;
    }
  } catch (err) {
    console.log('Error came while increasing post count');
    return;
  }
}
// ______________________________________________________________________________
